import * as React from 'react';
import { CONTEXT_UPDATE, FOCUS_OUTSIDE } from './constants';
import { useCallbackRef } from '../../hooks/useCallbackRef';
import { dispatchDiscreteCustomEvent } from '../../utils/dispatchDiscreteCustomEvent';

/**
 * Слушает, когда фокус происходит вне поддерева React.
 * Возвращает свойства для передачи корневому (узлу) поддерева, которое мы хотим проверить.
 */
export function useFocusOutside(onFocusOutside) {
  var ownerDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  var handleFocusOutside = useCallbackRef(onFocusOutside);
  var isFocusInsideReactTreeRef = React.useRef(false);
  React.useEffect(function () {
    var handleFocus = function handleFocus(event) {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        var eventDetail = {
          originalEvent: event
        };
        handleAndDispatchCustomEvent(FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    ownerDocument.addEventListener('focusin', handleFocus);
    return function () {
      return ownerDocument.removeEventListener('focusin', handleFocus);
    };
  }, [ownerDocument, handleFocusOutside]);
  return {
    onFocusCapture: function onFocusCapture() {
      return isFocusInsideReactTreeRef.current = true;
    },
    onBlurCapture: function onBlurCapture() {
      return isFocusInsideReactTreeRef.current = false;
    }
  };
}
export function dispatchUpdate() {
  var event = new CustomEvent(CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
export function handleAndDispatchCustomEvent(name, handler, detail, _ref) {
  var discrete = _ref.discrete;
  var target = detail.originalEvent.target;
  var event = new CustomEvent(name, {
    bubbles: false,
    cancelable: true,
    detail: detail
  });
  if (handler) {
    target.addEventListener(name, handler, {
      once: true
    });
  }
  if (discrete) {
    dispatchDiscreteCustomEvent(target, event);
  } else {
    target.dispatchEvent(event);
  }
}